import { LinkProps } from 'react-router-dom';

import IconArrowWithTail from 'components/icons/downArrow';

import { Container, StyledLink } from './styles';

interface LocalLinkProps extends LinkProps {
  decorated?: boolean;
}

const Link = ({ className, children, decorated, ...props }: LocalLinkProps) => {
  if (!decorated) {
    return (
      <StyledLink className={className} {...props}>
        {children}
      </StyledLink>
    );
  }

  return (
    <Container className={className}>
      <StyledLink {...props}>{children}</StyledLink>
      <IconArrowWithTail />
    </Container>
  );
};

export default Link;
